import { AsyncPipe, DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ImageSelectors } from '@app/store';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ItemShareComponent } from '../item-share/item-share.component';

@Component({
  selector: 'app-item-info',
  templateUrl: './item-info.component.html',
  styleUrls: ['./item-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, DecimalPipe, ItemShareComponent],
})
export class ItemInfoComponent {
  protected imageDescription$: Observable<string> = inject(Store).select(
    ImageSelectors.imageDescription,
  ) as Observable<string>;

  protected imageViews$: Observable<number> = inject(Store).select(
    ImageSelectors.imageViews,
  ) as Observable<number>;

  protected imageDownloads$: Observable<number> = inject(Store).select(
    ImageSelectors.imageDownloads,
  ) as Observable<number>;

  protected imageLocation$: Observable<string> = inject(Store).select(
    ImageSelectors.imageLocation,
  ) as Observable<string>;

  protected imageLicense$: Observable<string> = inject(Store).select(
    ImageSelectors.imageLicense,
  ) as Observable<string>;

  protected imageCamera$: Observable<string> = inject(Store).select(
    ImageSelectors.imageCamera,
  ) as Observable<string>;
}
